// pages/About.js
export default function About() {
    return (
      <div className="about-container">
        <h1>About $MINE</h1>
        <p>$MINE is a simple experiment on the DBK chain.</p>
        <p>Only 21,000,000 $MINE can ever exist, just like Bitcoin.</p>
        <p>To create $MINE, you must hold ETH on DBK Chain.</p>
        <p>Every minute, anyone holding at least 0.01 ETH can mint an amount of $MINE.</p>
        <p>This amount begins at 65,536 $MINE per ETH per minute. Every 210,000 $MINE minted, the rate halves.</p>
      </div>
    );
  }